import * as React from "react";
import { onboardingChecklistQuery } from "./OnboardingChecklistCard.gql";
import { useQuery } from "@apollo/client";
import { setAssistantFeedCardNotificationCount } from "@actions/chrome-extension.actions";
import { getCurrentOrg } from "@src/util/org.util";
import { connect } from "react-redux";
import { IReduxState } from "@reducers/root.reducer";
import { OnboardingChecklistCard } from "./OnboardingChecklistCard";

interface IProps extends IContainer {
  setAssistantFeedCardNotificationCount: typeof setAssistantFeedCardNotificationCount;
  assistantFeedCardNotificationCount: number;
}

interface IContainer {
  updateCardCount?: (count: number) => void;
  onClose: () => void;
}
export const OnboardingChecklistCardRendererCmpt = (props: IProps) => {
  const { loading, data } = useQuery(onboardingChecklistQuery, {
    fetchPolicy: "network-only",
  });
  const org = getCurrentOrg(data?.viewer || null);
  const {
    updateCardCount,
    assistantFeedCardNotificationCount,
    setAssistantFeedCardNotificationCount,
  } = props;

  if (!org || !org?.onboardingChecklist || loading) {
    return null;
  } else {
    // send udpated count to parent and set redux notification count
    updateCardCount && updateCardCount(1);
    if (assistantFeedCardNotificationCount < 1) {
      setAssistantFeedCardNotificationCount(1);
    }
  }

  const onDismissCard = () => {
    setAssistantFeedCardNotificationCount(0);
    props.onClose();
  };

  return <OnboardingChecklistCard org={org} onClose={onDismissCard} />;
};

function mapStateToProps(state: IReduxState, _ownProps: IContainer) {
  return {
    assistantFeedCardNotificationCount: state.webExtension.assistantFeedCardNotificationCount,
  };
}

export const OnboardingChecklistCardRenderer = connect(mapStateToProps, {
  setAssistantFeedCardNotificationCount,
})(OnboardingChecklistCardRendererCmpt);
